import { render } from "./PourquoiCertifier.vue?vue&type=template&id=581df642"
import script from "./PourquoiCertifier.vue?vue&type=script&lang=js"
export * from "./PourquoiCertifier.vue?vue&type=script&lang=js"

import "./PourquoiCertifier.vue?vue&type=style&index=0&id=581df642&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__